var map = {
	"./academy-local.js": 76,
	"./academy-preprod.js": 77,
	"./academy-prod.js": 78,
	"./dev-v2.js": 80,
	"./dev.js": 79,
	"./index.js": 8,
	"./local.js": 81,
	"./preprod.js": 82,
	"./prod.js": 83
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 217;